const selectStyles = "@layer crnt.components.select {\n\t@layer base {\n\t\t.crnt-boxed-input__trailing::slotted(crnt-icon) {\n\t\t\tcolor: var(--crnt-color-common-foreground-base);\n\t\t}\n\n\t\t::slotted(select) {\n\t\t\ttext-wrap: auto;\n\t\t}\n\t}\n}\n";

export { selectStyles as default };
